import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";
import Brand from "@/components/Brand";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Missing token"); return; }
    api.post("/auth/verify-email", { token })
      .then((r) => { setState("ok"); setMsg(r.data.message || "Email verified"); })
      .catch((e) => { setState("error"); setMsg(e.response?.data?.detail || "Verification failed"); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="max-w-sm w-full text-center space-y-4" data-testid="verify-page">
        <Brand />
        {state === "verifying" && (
          <>
            <Spinner size={32} className="mx-auto text-primary animate-spin" />
            <h2 className="font-heading text-2xl font-bold">Verifying…</h2>
            <p className="text-sm text-muted-foreground">Please wait a moment.</p>
          </>
        )}
        {state === "ok" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-500/10 flex items-center justify-center">
              <CheckCircle size={28} weight="duotone" className="text-emerald-600" />
            </div>
            <h2 className="font-heading text-2xl font-bold">Email verified</h2>
            <p className="text-sm text-muted-foreground">{msg}</p>
            <Link to="/login"><Button className="rounded-full" data-testid="verify-signin-button">Sign in now</Button></Link>
          </>
        )}
        {state === "error" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-destructive/10 flex items-center justify-center">
              <XCircle size={28} weight="duotone" className="text-destructive" />
            </div>
            <h2 className="font-heading text-2xl font-bold">Verification failed</h2>
            <p className="text-sm text-muted-foreground">{msg}</p>
            <Link to="/login"><Button variant="outline" className="rounded-full">Back to sign in</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
